import createLogger from 'redux-logger';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { routerReducer, routerMiddleware, push } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import thunk from 'redux-thunk';
import qs from 'query-string';
import api from './middleware/api';


const logger = createLogger();
const history = createHistory();
const middleware = routerMiddleware(history);

export default (reducer) => {

	const enhancers = [];

	if (process.env.NODE_ENV === 'production') {
		enhancers.push(applyMiddleware(thunk, api, middleware))
	} else {
		enhancers.push(applyMiddleware(thunk, api, logger, middleware))
	}

	const store = createStore(reducer, {
		query: qs.parse(location.search) || {}
	}, compose(...enhancers));

	// const store = createStore(
	// 	combineReducers({
	// 		...reducer,
	// 		router: routerReducer,
	// 		query: qs.parse(location.search) || {},
	// 	}),
	// 	compose(...enhancers)
	// )

	return store;
};




// WEBPACK FOOTER //
// ./src/baseRender.js